import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GenericResultViewComponent } from '../generic-result-view/generic-result-view.component';
import { InternLandingPageComponent } from '../../../../components-track/intern-landing-page/intern-landing-page.component';

@Component({
    selector: 'app-stream-result-list',
    standalone: false,
    templateUrl: './stream-result-list.component.html',
    styleUrl: './stream-result-list.component.scss'
})
export class StreamResultListComponent implements OnInit, OnChanges {
    dialog = inject(MatDialog);
    @Input() streamResults: any[] = [];
    @Input() streamId: string = ""
    @Output() streamResultEvent = new EventEmitter<any>();

    // Variables
    negativTopMargin: number = 0;
    userId: string = "";
    showResultList: boolean = false;
    counter: number = 0;
    sortResultIsRunning: boolean = false;
    loading: boolean = false;

    listToShow: any[] = [];
    ngOnInit(): void {
        this.counter = 0;
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['streamResults']) {
            this.listToShow = this.streamResults.filter(res => res.type !== "briefing-material");
        }
        // console.log('Stream results initialized:', this.streamResults);
        // console.log('Stream ID:', this.streamId);
    }

    toggleResultView() {
        if (this.listToShow?.length === 0) return;
        this.showResultList = !this.showResultList;
    }
    async downloadFile(item: any) {

        if (item.variant === "CLS_LP" && item.refId) {
            this.openInternLandingPage(item.refId);
            return;
        }

        // Open new

        let dia = await this.dialog.open(
            GenericResultViewComponent,
            { data: { ...item, streamId: this.streamId }, autoFocus: false, disableClose: true }
        );

        dia.afterClosed().subscribe(result => {
            if (!result) return;

            this.streamResultEvent.emit(result);
            this.toggleResultView();
        });
    }
    deleteFile(item: any) { }
    async openInternLandingPage(refId: string) {
        let dia = await this.dialog.open(InternLandingPageComponent, {
            panelClass: "feed-back-card",
            data: { projectId: refId }
        });
    }
}
